import {Fragment, useState} from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useSWR from 'swr';
import HorizontalCardsList from '../HorizontalCardsList';
import Search from '../shared/Search';
import { Box, Typography } from '@mui/material';
import { getTranslation } from '../../utils/translate';
import { SearchOutlined } from '@mui/icons-material';

const SearchDialog = (props) => {
    const {
        title = 'Search',
        helperText = '',
        headCells = [],
        onSelect,
        url,
        payload = {},
        responseHandler = () => [],
        searchOnly
    } = props;

    const [open, setOpen] = useState(false);
    const [searchResults, setSearchResults] = useState(null);
    const [totalCount, setTotalCount] = useState(null);
    const [fullWidth, setFullWidth] = useState(true);
    const [maxWidth, setMaxWidth] = useState('xs');
    const [selected, setSelected] = useState([]);

    const { data, isLoading } = useSWR(payload);

    let processedData = [];

    if (data) {
        processedData = responseHandler(data);
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleSelect = (selected) => {
        console.log('selected', selected);
        setSelected(selected);
    };

    const handleClose = () => {
        if (onSelect) {
            onSelect(selected);
        }
        setOpen(false);
    };

    const handleSearchTriggered = () => {
        console.log('handleSearchTriggered');
    }

    const handleSearchCleared = () => {
        setSearchResults(null);
    }

    const handleSearchComplete = (results) => {
        // check if beefCuts is in the results
        if (results?.beefCuts) {
            setTotalCount()
            setSearchResults(results?.beefCuts?.data
                ?.map(beefCut => {
                    const translatedBeefCut = getTranslation(beefCut, { key: 'languages_id', code: 'en-US' });
                    const imageUrl = `${process.env.REACT_APP_API_URL}/assets/${beefCut?.image}`;
    
                    return {
                        id: beefCut?.id,
                        title: translatedBeefCut?.name || '',
                        description: translatedBeefCut?.description || '',
                        imageUrl: imageUrl || '',
                        data: beefCut,
                        url: `/beef-cuts/${beefCut?.id}`,
                    }
                }) || null);
        }

        if (results?.recipes) {
            setSearchResults(results?.recipes?.data
                ?.map(item => {
                    return {
                        id: item.id,
                        title: item?.title || '',
                        description: item?.description || '',
                        imageUrl: item.image,
                        data: item,
                        url: `/recipes/${item?.id}`,
                    }
                }) || null);
        }

        if (results?.barcodes) {
            setSearchResults(results?.barcodes?.data
                ?.map(item => {
                    return {
                        id: item.id,
                        title: item?.title || '',
                        description: item?.description || '',
                        imageUrl: item.image,
                        data: item,
                        url: `/barcodes/${item?.id}`,
                    }
                }) || null);
        }
    }

    return (
        <Fragment>
            <Button
                variant="outlined"
                onClick={handleClickOpen}
                sx={{
                    borderRadius: '2rem',
                    color: '#000',
                    background: '#efeeee',
                    borderColor: '#e0e0e0',
                    px: 4,
                }}
                endIcon={<SearchOutlined />}
                size={'small'}
            >
                Search
            </Button>
            <Dialog
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                open={open}
                onClose={handleClose}
            >
                <DialogTitle
                    sx={{
                        borderBottom: '1px solid #e0e0e0',
                    }}
                >
                    <Typography
                        className='form-title'
                    >
                        {title}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '1rem',
                        }}
                    >
                        {helperText}
                    </Typography>

                    <Box
                        sx={{
                            mt: 1,
                        }}
                    >
                        <Search
                            handleSearchComplete={handleSearchComplete}
                            handleSearchTriggered={handleSearchTriggered}
                            handleSearchCleared={handleSearchCleared}
                            searchOnly={searchOnly}
                            storageKey={searchOnly}
                            compact
                        />
                    </Box>
                </DialogTitle>

                <DialogContent
                    sx={{
                        mt: 4,
                    }}
                >
                    <HorizontalCardsList
                        headCells={headCells}
                        rows={
                            (searchResults || processedData)?.map(item => {
                                return {
                                    id: item?.id,
                                    title: item?.title || '',
                                    description: item?.description || '',
                                    imageUrl: item.imageUrl || '',
                                    url: item.url || '',
                                    data: item.data
                                }
                            })
                        }
                    />
                </DialogContent>

                <DialogActions
                    sx={{
                        borderTop: '1px solid #e0e0e0',
                    }}
                >
                    <Button
                        onClick={() => {
                            setOpen(false);
                        }}
                        color="info"
                        variant='contained'
                    >
                        Done
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}

export default SearchDialog